// MainQuestionnaireTable.jsx

import React, { useMemo } from "react";
import { Table } from "antd";
import { Rating } from "@mui/material";

const MainQuestionnaireTable = ({
  appraiseeQuestions = [],
  appraiserQuestions = [],
  isView = false,
  validationErrors = {},
  onAppraiserChange,
}) => {
  const rows = useMemo(() => {
    return appraiserQuestions.map((appraiserQ, idx) => ({
      key: idx,
      sno: idx + 1,
      appraiseeQ: appraiseeQuestions[idx] || null,
      appraiserQ,
    }));
  }, [appraiseeQuestions, appraiserQuestions]);

  const appraiseeRatingSummary = useMemo(() => {
    console.log("appraiseeQuestions", appraiseeQuestions);
    const ratingQs = appraiseeQuestions.filter((q) => q.formType === "RATING");
    if (ratingQs.length === 0) return null;
    const totalStars = ratingQs.reduce((s, q) => s + (q.starCount || 5), 0);
    const totalValue = ratingQs.reduce(
      (s, q) => s + (Number(q.answer) || 0),
      0
    );
    const percentage = totalStars > 0 ? (totalValue / totalStars) * 100 : 0;
    return { totalStars, totalValue, percentage };
  }, [appraiseeQuestions]);

  const appraiserRatingSummary = useMemo(() => {
    const ratingQs = appraiserQuestions.filter((q) => q.formType === "RATING");
    if (ratingQs.length === 0) return null;
    const totalStars = ratingQs.reduce((s, q) => s + (q.starCount || 5), 0);
    const totalValue = ratingQs.reduce(
      (s, q) => s + (Number(q.answer) || 0),
      0
    );
    const percentage = totalStars > 0 ? (totalValue / totalStars) * 100 : 0;
    return { totalStars, totalValue, percentage };
  }, [appraiserQuestions]);

  const handleChange = (appraiserQ, value) => {
    const updated = appraiserQuestions.map((q) =>
      q.id === appraiserQ.id ? { ...q, answer: value } : q
    );
    onAppraiserChange?.(updated);
  };

  // ✅ Always plain text for appraisee
  const renderAppraiseeResponse = (appraiseeQ) => {
    if (!appraiseeQ) return <span style={{ color: "#bbb" }}>–</span>;
    return appraiseeQ.answer ? (
      <span style={{ color: "#333" }}>{appraiseeQ.answer}</span>
    ) : (
      <span style={{ color: "#bbb" }}>–</span>
    );
  };

  const renderAppraiserResponse = (appraiserQ) => {
    if (!appraiserQ) return <span style={{ color: "#bbb" }}>–</span>;
    const hasError = validationErrors[appraiserQ.id];

    const getDisplayValue = () => {
      if (appraiserQ.formType === "CHECKBOX") {
        return appraiserQ.options
          ?.filter((o) => o.isChecked)
          .map((o) => o.optionText)
          .join(", ");
      }
      return appraiserQ.answer;
    };

    // ✅ Show plain text if view mode OR answer already exists
    if (isView || getDisplayValue()) {
      const val = getDisplayValue();
      return val ? (
        <span style={{ color: "#333" }}>{val}</span>
      ) : (
        <span style={{ color: "#bbb" }}>–</span>
      );
    }

    // ✅ Edit mode controls — only shown when answer is empty
    // if (appraiserQ.formType === "RATING") {
    //   return (
    //     <div id={`question-${appraiserQ.id}`}>
    //       <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
    //         <Rating
    //           value={Number(appraiserQ.answer) || 0}
    //           max={appraiserQ.starCount || 0}
    //           size="small"
    //           onChange={(_, newValue) => handleChange(appraiserQ, newValue)}
    //           sx={{ "& .MuiRating-iconFilled": { color: "#fbc02d" } }}
    //         />
    //         {appraiserQ.answer && (
    //           <span style={{ fontSize: 13, color: "#555" }}>
    //             {appraiserQ.answer}
    //           </span>
    //         )}
    //       </div>
    //       {hasError && (
    //         <div style={{ color: "#e53935", fontSize: 11, marginTop: 2 }}>
    //           Required
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    // if (["PARAGRAPH", "SHORT_ANS"].includes(appraiserQ.formType)) {
    //   return (
    //     <div id={`question-${appraiserQ.id}`}>
    //       <textarea
    //         value={appraiserQ.answer || ""}
    //         onChange={(e) => handleChange(appraiserQ, e.target.value)}
    //         rows={2}
    //         style={{
    //           width: "100%",
    //           padding: "6px 10px",
    //           borderRadius: 6,
    //           border: `1px solid ${hasError ? "#e53935" : "#e0e0e0"}`,
    //           fontSize: 13,
    //           resize: "vertical",
    //           outline: "none",
    //           fontFamily: "inherit",
    //           minWidth: 160,
    //         }}
    //         placeholder="Enter response..."
    //       />
    //       {hasError && (
    //         <div style={{ color: "#e53935", fontSize: 11, marginTop: 2 }}>
    //           Required
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    // if (appraiserQ.formType === "MULIPLE_CHOICE") {
    //   return (
    //     <div id={`question-${appraiserQ.id}`}>
    //       {appraiserQ.options?.map((opt, i) => (
    //         <label
    //           key={i}
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             marginBottom: 4,
    //             fontSize: 13,
    //             cursor: "pointer",
    //           }}
    //         >
    //           <input
    //             type="radio"
    //             name={`appraiser-radio-${appraiserQ.id}`}
    //             value={opt.optionText}
    //             checked={appraiserQ.answer === opt.optionText}
    //             onChange={(e) => handleChange(appraiserQ, e.target.value)}
    //             style={{ marginRight: 6 }}
    //           />
    //           {opt.optionText}
    //         </label>
    //       ))}
    //       {hasError && (
    //         <div style={{ color: "#e53935", fontSize: 11, marginTop: 2 }}>
    //           Required
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    // if (appraiserQ.formType === "DROPDOWN") {
    //   return (
    //     <div id={`question-${appraiserQ.id}`}>
    //       <select
    //         value={appraiserQ.answer || ""}
    //         onChange={(e) => handleChange(appraiserQ, e.target.value)}
    //         style={{
    //           padding: "6px 10px",
    //           borderRadius: 6,
    //           border: `1px solid ${hasError ? "#e53935" : "#e0e0e0"}`,
    //           fontSize: 13,
    //           outline: "none",
    //           minWidth: 140,
    //           background: "#fff",
    //         }}
    //       >
    //         <option value="">Choose</option>
    //         {appraiserQ.options?.map((opt, i) => (
    //           <option key={i} value={opt.optionText}>
    //             {opt.optionText}
    //           </option>
    //         ))}
    //       </select>
    //       {hasError && (
    //         <div style={{ color: "#e53935", fontSize: 11, marginTop: 2 }}>
    //           Required
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    // if (appraiserQ.formType === "CHECKBOX") {
    //   return (
    //     <div id={`question-${appraiserQ.id}`}>
    //       {appraiserQ.options?.map((opt, i) => (
    //         <label
    //           key={i}
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             marginBottom: 4,
    //             fontSize: 13,
    //             cursor: "pointer",
    //           }}
    //         >
    //           <input
    //             type="checkbox"
    //             checked={opt.isChecked || false}
    //             onChange={(e) => {
    //               const updated = appraiserQuestions.map((q) => {
    //                 if (q.id !== appraiserQ.id) return q;
    //                 const updatedOptions = q.options.map((o, oi) =>
    //                   oi === i ? { ...o, isChecked: e.target.checked } : o
    //                 );
    //                 return {
    //                   ...q,
    //                   options: updatedOptions,
    //                   answer: updatedOptions,
    //                 };
    //               });
    //               onAppraiserChange?.(updated);
    //             }}
    //             style={{ marginRight: 6 }}
    //           />
    //           {opt.optionText}
    //         </label>
    //       ))}
    //       {hasError && (
    //         <div style={{ color: "#e53935", fontSize: 11, marginTop: 2 }}>
    //           Required
    //         </div>
    //       )}
    //     </div>
    //   );
    // }

    return <span style={{ color: "#bbb" }}>–</span>;
  };

  const renderDifference = (appraiseeQ, appraiserQ) => {
    if (
      !appraiseeQ ||
      !appraiserQ ||
      appraiseeQ.formType !== "RATING" ||
      !appraiseeQ.answer ||
      !appraiserQ.answer
    )
      return <span style={{ color: "#bbb" }}>–</span>;

    const diff =
      (Number(appraiserQ.answer) || 0) - (Number(appraiseeQ.answer) || 0);
    return (
      <span
        style={{ color: diff >= 0 ? "#4caf50" : "#e53935", fontWeight: 600 }}
      >
        {diff > 0 ? `+${diff}` : diff}
      </span>
    );
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: 60,
      align: "center",
    },
    {
      title: "Question",
      key: "question",
      width: "30%",
      render: (_, record) => (
        <span
          style={{
            fontWeight: 500,
            color: "#333",
            whiteSpace: "pre-line",
            lineHeight: 1.6,
            display: "block",
          }}
        >
          {record.appraiserQ?.question}
        </span>
      ),
    },
    {
      title: "Appraisee's Response",
      key: "appraiseeResponse",
      render: (_, record) => renderAppraiseeResponse(record.appraiseeQ),
    },
    {
      title: "Appraiser's Response",
      key: "appraiserResponse",
      render: (_, record) => renderAppraiserResponse(record.appraiserQ),
    },
    {
      title: "Difference",
      key: "difference",
      align: "center",
      render: (_, record) =>
        renderDifference(record.appraiseeQ, record.appraiserQ),
    },
  ];

  return (
    <div
      style={{
        border: "1px solid #e8e8e8",
        borderRadius: 12,
        overflow: "hidden",
        marginTop: 16,
        marginBottom: 24,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      }}
    >
      <Table
        columns={columns}
        dataSource={rows}
        pagination={false}
        bordered={false}
        size="middle"
        style={{ borderRadius: 0 }}
      />

      {/* Score Footer - only show if there are rating questions */}
      {(appraiseeRatingSummary || appraiserRatingSummary) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            padding: "14px 24px",
            backgroundColor: "#eef2ff",
            borderTop: "1px solid #e0e7ff",
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", fontSize: 15 }}>
            <span style={{ fontWeight: 600, color: "#444" }}>
              Appraisee's Score:
            </span>
            {appraiseeRatingSummary ? (
              <>
                <b style={{ color: "#1677ff", marginLeft: 6 }}>
                  {appraiseeRatingSummary.totalValue}
                </b>
                <span style={{ color: "#555" }}>
                  {" "}
                  / {appraiseeRatingSummary.totalStars}
                </span>
                <span
                  style={{ color: "#555", fontStyle: "italic", marginLeft: 8 }}
                >
                  ({appraiseeRatingSummary.percentage.toFixed(0)}%)
                </span>
              </>
            ) : (
              <span style={{ color: "#bbb", marginLeft: 6 }}>–</span>
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center", fontSize: 15 }}>
            <span style={{ fontWeight: 600, color: "#444" }}>
              Appraiser's Score:
            </span>

            <>
              <b style={{ color: "#1677ff", marginLeft: 6 }}>
                {appraiserRatingSummary.totalValue}
              </b>
              <span style={{ color: "#555" }}>
                {" "}
                / {appraiserRatingSummary.totalStars}
              </span>
              <span
                style={{ color: "#555", fontStyle: "italic", marginLeft: 8 }}
              >
                ({appraiserRatingSummary.percentage.toFixed(0)}%)
              </span>
            </>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainQuestionnaireTable;
